<div class="cadastro-parceiros-container">
  <umkt-back-button></umkt-back-button>

  <div class="header-section">
    <div class="header-content">
      <div class="header-text">
        <div class="header-desktop">
          <h1 class="page-title">
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLine1' | i18n }}</span>
            <br class="desktop-title-break" />
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLine2' | i18n }}</span>
            <br class="desktop-title-break" />
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLine3Prefix' | i18n }} </span><span class="page-title-highlight">{{ 'pages.partnerRegistration.header.titleLine3' | i18n }}</span>
          </h1>
          <p class="partner-header-subtitle">{{ 'pages.partnerRegistration.header.subtitle' | i18n }}</p>
        </div>

        <div class="header-mobile">
          <h1 class="page-title">
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLineMobile1' | i18n }}</span>
            <br class="partner-highlights-subtitle-break-mobile" />
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLineMobile2' | i18n }}</span>
            <br class="partner-highlights-subtitle-break-mobile" />
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLineMobile3' | i18n }}</span>
            <br class="partner-highlights-subtitle-break-mobile" />
            <span class="page-title-line">{{ 'pages.partnerRegistration.header.titleLineMobile4Prefix' | i18n }} </span><span class="page-title-highlight">{{ 'pages.partnerRegistration.header.titleLineMobile4' | i18n }}</span>
          </h1>
          <p class="partner-header-subtitle">{{ 'pages.partnerRegistration.header.subtitleMobile' | i18n }}</p>
        </div>

        <ustore-button
          [textColor]="'var(--color-inverted)'"
          [size]="'large'"
          [backgroundColor]="'#DA291C'"
          [text]="'pages.partnerRegistration.header.button' | i18n"
          [rounded]="'default'"
          (onClick)="onScrollToInscription()"
        ></ustore-button>

        <span class="header-register-info">{{ 'pages.partnerRegistration.header.registerInfoLabel' | i18n }}</span>
      </div>

      <div class="header-image">
        <img class="header-image-content" [src]="'assets/images/potencialize_crescimento.png' | imageFallback" alt="" />
      </div>
    </div>

  </div>
  <div class="companies-band">
    <div class="companies-band-content">
      <span class="companies-band-title">{{ 'pages.partnerRegistration.header.ecosystemTitle' | i18n }}</span>
      <div class="companies-list">
        <img src="https://mondrian.claro.com.br/brands/app/32px-alternative/oboticario.svg" class="company-logo" alt="O Boticário">
        <img src="https://mondrian.claro.com.br/brands/app/32px-alternative/google.svg" class="company-logo" alt="Google"/>
        <img src="https://mondrian.claro.com.br/brands/app/32px-alternative/microsoft-365.svg" class="company-logo" alt="Microsoft 365"/>
      </div>
    </div>
  </div>
  <div class="header-stats">
    <div class="stats-texts">
      <div class="stats-texts-desktop">
        <span class="status-title">{{ 'pages.partnerRegistration.header.statsLabel1' | i18n }}</span>
        <div class="stats-highlight-row">
          <span class="status-highlight">{{ 'pages.partnerRegistration.header.statsLabel2' | i18n }}</span>
          <span class="status-subtitle">{{ 'pages.partnerRegistration.header.statsLabel3' | i18n }}</span>
        </div>
      </div>
      <div class="stats-texts-mobile">
        <span class="status-title">{{ 'pages.partnerRegistration.header.statsLabel1Mobile' | i18n }}</span>
        <span class="status-title">{{ 'pages.partnerRegistration.header.statsLabel2Mobile' | i18n }}&nbsp;<span class="status-highlight">{{ 'pages.partnerRegistration.header.statsLabel3Mobile' | i18n }}</span></span>
        <span class="status-subtitle">{{ 'pages.partnerRegistration.header.statsLabel4Mobile' | i18n }}</span>
      </div>
    </div>
    <div class="stats-container">
      <div class="stat-item" *ngFor="let stat of headerStats">
        <div class="stat-value"><sup *ngIf="headerStats.indexOf(stat) < 2" class="stat-value-sup">+</sup>{{ stat.value }}</div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
    </div>
  </div>

  <section class="partner-highlights-section" aria-labelledby="partner-highlights-title partner-highlights-title-mobile">
    <div class="partner-highlights-top-gap" aria-hidden="true"></div>
    <div class="partner-highlights-content">
      <div class="partner-highlights-main">
        <div class="partner-highlights-text-group">
          <h2 id="partner-highlights-title" class="partner-highlights-title">
            {{ 'pages.partnerRegistration.highlights.title' | i18n }}
          </h2>

          <h2 id="partner-highlights-title-mobile" class="partner-highlights-title-mobile">
            {{ 'pages.partnerRegistration.highlights.titleMobilePart1' | i18n }}
            <br class="partner-highlights-subtitle-break-mobile" />
            {{ 'pages.partnerRegistration.highlights.titleMobilePart2' | i18n }}
          </h2>
          <p class="partner-highlights-subtitle">
            <span class="partner-highlights-subtitle-desktop">
              {{ 'pages.partnerRegistration.highlights.subtitleDesktop' | i18n }}
            </span>
            <span class="partner-highlights-subtitle-mobile">
              {{ 'pages.partnerRegistration.highlights.subtitleMobilePart1' | i18n }}
              <br class="partner-highlights-subtitle-break-mobile" />
              {{ 'pages.partnerRegistration.highlights.subtitleMobilePart2' | i18n }}
            </span>
          </p>
        </div>
        <div class="partner-highlight-cards">
          <umkt-highlight-card
            [title]="'pages.partnerRegistration.form.highlightCard.accessTitle' | i18n"
            [subtitle]="'pages.partnerRegistration.form.highlightCard.accessSubtitle' | i18n"
            [icon]="{ name: 'mundo', type: 'mondrian-icons' }"
          >
          </umkt-highlight-card>
          <umkt-highlight-card
            [title]="'pages.partnerRegistration.form.highlightCard.trustedBrandTitle' | i18n"
            [subtitle]="'pages.partnerRegistration.form.highlightCard.trustedBrandSubtitle' | i18n"
            [icon]="{ name: 'escudo', type: 'mondrian-icons' }"
            [iconAriaLabel]="'pages.partnerRegistration.form.highlightCard.trustedBrandTitle' | i18n"
          >
          </umkt-highlight-card>
          <umkt-highlight-card
            [title]="'pages.partnerRegistration.form.highlightCard.scaleTitle' | i18n"
            [subtitle]="'pages.partnerRegistration.form.highlightCard.scaleSubtitle' | i18n"
            [icon]="{ name: 'foguete', type: 'mondrian-icons' }"
            [iconAriaLabel]="'pages.partnerRegistration.form.highlightCard.scaleTitle' | i18n"
          >
          </umkt-highlight-card>
        </div>
      </div>

      <div class="partner-benefits-container">
        <div class="partner-benefits-header">
          <div class="partner-benefits-title-desktop">
            <span class="partner-benefits-title">{{ 'pages.partnerRegistration.benefits.titleLine1' | i18n }}</span>
            <br class="desktop-title-break" />
            <span class="partner-benefits-title">{{ 'pages.partnerRegistration.benefits.titleLine2Prefix' | i18n }} <span class="partner-benefits-highlight">{{ 'pages.partnerRegistration.benefits.titleLine2' | i18n }}</span>.</span>
          </div>
          <div class="partner-benefits-title-mobile">
            <span class="partner-benefits-title">{{ 'pages.partnerRegistration.benefits.titleLine1Mobile' | i18n }}</span>
            <br />
            <span class="partner-benefits-title">{{ 'pages.partnerRegistration.benefits.titleLine2PrefixMobile' | i18n }} </span><span class="partner-benefits-highlight">{{ 'pages.partnerRegistration.benefits.titleLine2Mobile' | i18n }}</span>
          </div>

          <div class="partner-benefits-description partner-benefits-description-desktop">
            <span>{{ 'pages.partnerRegistration.benefits.subtitleLine1' | i18n }}</span>
            <br />
            <span>{{ 'pages.partnerRegistration.benefits.subtitleLine2' | i18n }}</span>
            <br />
            <span>{{ 'pages.partnerRegistration.benefits.subtitleLine3' | i18n }}</span>
          </div>
          <div class="partner-benefits-description partner-benefits-description-mobile">
            <span>{{ 'pages.partnerRegistration.benefits.subtitleMobile' | i18n }}</span>
          </div>
        </div>
        
        <div class="partner-benefits-list">
          <div class="partner-benefits-list-item">
            <span class="mdn-Icon-globo-com-esferas mdn-Icon--md partner-benefits-icon" aria-label="globo-com-esferas"></span>
            <span>{{ 'pages.partnerRegistration.benefits.benefitsList.item1' | i18n }}</span>
          </div>
          <div class="partner-benefits-list-item">
            <span class="mdn-Icon-conexao-globo mdn-Icon--md partner-benefits-icon" aria-label="conexao-globo"></span>
            <span>{{ 'pages.partnerRegistration.benefits.benefitsList.item2' | i18n }}</span>
          </div>
          <div class="partner-benefits-list-item">
            <span class="mdn-Icon-grafico-barras mdn-Icon--md partner-benefits-icon" aria-label="grafico-barras"></span>
            <span>{{ 'pages.partnerRegistration.benefits.benefitsList.item3' | i18n }}</span>
          </div>
          <div class="partner-benefits-list-item">
            <span class="mdn-Icon-solar-na-escuta mdn-Icon--md partner-benefits-icon" aria-label="solar-na-escuta"></span>
            <span>{{ 'pages.partnerRegistration.benefits.benefitsList.item4' | i18n }}</span>
          </div>
        </div>
      </div>

      <div class="partner-highlights-stepper">
        <h2 class="stepper-title-custom">
          <span class="stepper-title-part1">{{ 'pages.partnerRegistration.howItWorks.title' | i18n }} <span class="stepper-title-part2">{{ 'pages.partnerRegistration.howItWorks.title2' | i18n }}</span>.</span>
        </h2>
        <umkt-horizontal-stepper
          [steps]="partnerJourneySteps"
          [currentStepIndex]="3"
          [showTitle]="false"
          [showSubtitle]="true"
          [subtitle]="'pages.partnerRegistration.howItWorks.subtitle' | i18n"
          [ariaLabel]="'pages.partnerRegistration.howItWorks.ariaLabel' | i18n"
        >
        </umkt-horizontal-stepper>
      </div>
    </div>

    <div class="partner-eligibility-cta-content">
      <div class="partner-eligibility-container">
        <span class="mdn-Icon-foguete partner-eligibility-background-icon" aria-hidden="true"></span>
        <div class="partner-eligibility-header">
          <div>
            <span class="partner-eligibility-title">{{ 'pages.partnerRegistration.eligibility.titlePart1' | i18n }}</span>
            <br class="desktop-title-break" />
            <span class="partner-eligibility-title">{{ 'pages.partnerRegistration.eligibility.titlePart2' | i18n }}</span>
          </div>

          <div class="partner-eligibility-list">
            <div class="partner-eligibility-list-item">
              <span class="mdn-Icon-nuvem mdn-Icon--md partner-eligibility-icon" aria-label="Nuvem"></span>
              <span>{{ 'pages.partnerRegistration.eligibility.eligibilityList.item1' | i18n }}</span>
            </div>
            <div class="partner-eligibility-list-item">
              <span class="mdn-Icon-grafico-crescimento mdn-Icon--md partner-eligibility-icon" aria-label="Gráfico de crescimento"></span>
              <span>{{ 'pages.partnerRegistration.eligibility.eligibilityList.item2' | i18n }}</span>
            </div>
            <div class="partner-eligibility-list-item">
              <span class="mdn-Icon-maos-acordo mdn-Icon--md partner-eligibility-icon" aria-label="Mãos em acordo"></span>
              <span>{{ 'pages.partnerRegistration.eligibility.eligibilityList.item3' | i18n }}</span>
            </div>
            <div class="partner-eligibility-list-item">
              <span class="mdn-Icon-raio mdn-Icon--md partner-eligibility-icon" aria-label="Raio"></span>
              <span>{{ 'pages.partnerRegistration.eligibility.eligibilityList.item4' | i18n }}</span>
            </div>
          </div>
        </div>
        

        <div class="invite-card-container">
          <div class="invite-card">
            <div class="invite-card-header">
              <span class="invite-card-title">{{ 'pages.partnerRegistration.eligibility.titleCard' | i18n }}</span>
              <div class="invite-card-description-desktop">
                <span class="invite-card-description">{{ 'pages.partnerRegistration.eligibility.descriptionCard1' | i18n }}</span>
                <br />
                <span class="invite-card-description">{{ 'pages.partnerRegistration.eligibility.descriptionCard2' | i18n }}</span>
                <br />
                <span class="invite-card-description">{{ 'pages.partnerRegistration.eligibility.descriptionCard3' | i18n }}</span>
                <br />
                <span class="invite-card-description">{{ 'pages.partnerRegistration.eligibility.descriptionCard4' | i18n }}</span>
              </div>
              <div class="invite-card-description-mobile">
                <span class="invite-card-description">{{ 'pages.partnerRegistration.eligibility.descriptionCardMobile' | i18n }}</span>
              </div>
            </div>
  
            <div class="invite-card-footer">
              <span class="invite-card-footer-title">{{ 'pages.partnerRegistration.eligibility.footerCardTitle' | i18n }}</span>
              <span class="invite-card-footer-subtitle">{{ 'pages.partnerRegistration.eligibility.footerCardSubtitle' | i18n }}</span>
            </div>
          </div>
        </div>
      </div>

      <section class="partner-cta-section">
        <div class="partner-cta-content">
          <div class="partner-cta-text-group">
            <div class="partner-cta-title-group-desktop">
              <span class="partner-cta-title">{{ 'pages.partnerRegistration.ctaSection.titleLine1' | i18n }}</span>
              <span class="partner-cta-title">{{ 'pages.partnerRegistration.ctaSection.titleLine2Prefix' | i18n }}&nbsp;<span class="partner-cta-highlight">{{ 'pages.partnerRegistration.ctaSection.titleLine2' | i18n }}</span>.</span>
            </div>
            <div class="partner-cta-title-group-mobile">
              <span class="partner-cta-title">{{ 'pages.partnerRegistration.ctaSection.titleLine1' | i18n }}</span>
              <br />
              <span class="partner-cta-title">{{ 'pages.partnerRegistration.ctaSection.titleLine2Prefix' | i18n }}</span>
              <br />
              <span class="partner-cta-title partner-cta-highlight">{{ 'pages.partnerRegistration.ctaSection.titleLine2' | i18n }}</span>.
            </div>

            <p class="partner-cta-description partner-cta-description-desktop">
              {{ 'pages.partnerRegistration.ctaSection.descriptionLine1' | i18n }}
              <br />
              {{ 'pages.partnerRegistration.ctaSection.descriptionLine2' | i18n }}
            </p>
            <p class="partner-cta-description partner-cta-description-mobile">
              {{ 'pages.partnerRegistration.ctaSection.descriptionLineMobile' | i18n }}
            </p>
          </div>
          <div class="partner-cta-action">
            <ustore-button
              [textColor]="'var(--color-inverted)'"
              [size]="'medium'"
              [backgroundColor]="'#DA291C'"
              [text]="'pages.partnerRegistration.ctaSection.button' | i18n"
              [rounded]="'default'"
              (onClick)="onScrollToInscription()"
            ></ustore-button>
          </div>
        </div>
        <div class="partner-cta-footer-gap" aria-hidden="true"></div>
      </section>
    </div>
  </section>
</div>
